import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Profile from './components/Profile';
import Home from './components/Home';
import DepartmentMenu from './components/DepartmentMenu';


const AppRouter = () => {
return (
    <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/profile" element={<Profile />} />
    <Route path="/DepartmentMenu" element={<DepartmentMenu/>}/>
    </Routes>
);
};

export default AppRouter;
